import { useMemo } from 'react';
import { OptionData } from '../../model/OptionData';
import { Filtro } from './Filtro';
import { useRubros } from './useRubros';
import { useNavigate } from 'react-router-dom';
import { RubroData } from '../../model/RubroData';

export const FiltroRubro = () => {
  const navigate = useNavigate();

  const useNavigateToRubro = (value: string): void => {
    const url = RubroData.getUrl(value);

    if (url) navigate(url, { replace: true });
  };

  const rubros = useRubros();
  const opcionesRubros = useMemo(
    () =>
      rubros?.items
        ?.filter((rubro) => rubro.labelName?.trim?.().length > 0 && rubro.id?.trim?.().length > 0)
        ?.map((rubro) => new OptionData(rubro.id.trim(), rubro.labelName)),
    [rubros]
  );

  return (
    <>
      <Filtro
        nombre="Filtrar por rubro"
        margin={['0px 0px 20px 0px', '0px 16px 0px 0px']}
        width={['100%', '50%']}
        maxWidth={['null', '240px']}
        opciones={opcionesRubros}
        onChange={useNavigateToRubro}
      />
    </>
  );
};
